var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 162,
    viewBox: "0 0 91 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Buildings--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.000362396 12.6162H33.501V237.254H0.000362396V12.6162Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.8777 34.5049H30.0464V47.6396H23.8777V34.5049Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M23.8777 51.0786H30.0464V64.2133H23.8777V51.0786Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M23.8777 67.644H30.0464V80.7788H23.8777V67.644Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M23.8777 84.2095H30.0464V97.3442H23.8777V84.2095Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M23.8777 100.783H30.0464V113.918H23.8777V100.783Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M23.8777 117.357H30.0464V130.492H23.8777V117.357Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M23.8777 133.914H30.0464V147.049H23.8777V133.914Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M23.8777 150.488H30.0464V163.623H23.8777V150.488Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M23.8777 34.5049H30.0464V47.6396H23.8777V34.5049Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M23.8777 51.0786H30.0464V64.2133H23.8777V51.0786Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M23.8777 67.644H30.0464V80.7788H23.8777V67.644Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M23.8777 84.2095H30.0464V97.3442H23.8777V84.2095Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M23.8777 100.783H30.0464V113.918H23.8777V100.783Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M23.8777 117.357H30.0464V130.492H23.8777V117.357Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M23.8777 133.914H30.0464V147.049H23.8777V133.914Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M23.8777 150.488H30.0464V163.623H23.8777V150.488Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M13.6663 34.5049H19.835V47.6396H13.6663V34.5049Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M13.6663 51.0786H19.835V64.2133H13.6663V51.0786Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M13.6663 67.644H19.835V80.7788H13.6663V67.644Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M13.6663 84.2095H19.835V97.3442H13.6663V84.2095Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M13.6663 100.783H19.835V113.918H13.6663V100.783Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M13.6663 117.357H19.835V130.492H13.6663V117.357Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M13.6663 133.914H19.835V147.049H13.6663V133.914Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M13.6663 150.488H19.835V163.623H13.6663V150.488Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M13.6663 34.5049H19.835V47.6396H13.6663V34.5049Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M13.6663 51.0786H19.835V64.2133H13.6663V51.0786Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M13.6663 67.644H19.835V80.7788H13.6663V67.644Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M13.6663 84.2095H19.835V97.3442H13.6663V84.2095Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M13.6663 100.783H19.835V113.918H13.6663V100.783Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M13.6663 117.357H19.835V130.492H13.6663V117.357Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M13.6663 133.914H19.835V147.049H13.6663V133.914Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M13.6663 150.488H19.835V163.623H13.6663V150.488Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M3.45438 34.5049H9.62305V47.6396H3.45438V34.5049Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M3.45438 51.0786H9.62305V64.2133H3.45438V51.0786Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M3.45438 67.644H9.62305V80.7788H3.45438V67.644Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M3.45438 84.2095H9.62305V97.3442H3.45438V84.2095Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M3.45438 100.783H9.62305V113.918H3.45438V100.783Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M3.45438 117.357H9.62305V130.492H3.45438V117.357Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M3.45438 133.914H9.62305V147.049H3.45438V133.914Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M3.45438 150.488H9.62305V163.623H3.45438V150.488Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M3.45438 34.5049H9.62305V47.6396H3.45438V34.5049Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M3.45438 51.0786H9.62305V64.2133H3.45438V51.0786Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M3.45438 67.644H9.62305V80.7788H3.45438V67.644Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M3.45438 84.2095H9.62305V97.3442H3.45438V84.2095Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M3.45438 100.783H9.62305V113.918H3.45438V100.783Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M3.45438 117.357H9.62305V130.492H3.45438V117.357Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M3.45438 133.914H9.62305V147.049H3.45438V133.914Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M3.45438 150.488H9.62305V163.623H3.45438V150.488Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M33.5007 25.207H90.7744V27.5661H33.5007V25.207Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M33.5007 0H70.3608V12.6162H33.5007V0Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M33.5009 12.6162L16.1812 12.6162V-2.28882e-05L33.5009 -2.28882e-05V12.6162Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M74.6221 34.5049H84.6343V47.6396H74.6221V34.5049Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M74.6221 51.0786H84.6343V64.2133H74.6221V51.0786Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M74.6221 67.644H84.6343V80.7788H74.6221V67.644Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M74.6221 84.2095H84.6343V97.3442H74.6221V84.2095Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M74.6221 100.783H84.6343V113.918H74.6221V100.783Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M74.6221 117.357H84.6343V130.492H74.6221V117.357Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M74.6221 133.914H84.6343V147.049H74.6221V133.914Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M74.6221 150.488H84.6343V163.623H74.6221V150.488Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M74.6221 34.5049H84.6343V47.6396H74.6221V34.5049Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M74.6221 51.0786H84.6343V64.2133H74.6221V51.0786Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M74.6221 67.644H84.6343V80.7788H74.6221V67.644Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M74.6221 84.2095H84.6343V97.3442H74.6221V84.2095Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M74.6221 100.783H84.6343V113.918H74.6221V100.783Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M74.6221 117.357H84.6343V130.492H74.6221V117.357Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M74.6221 133.914H84.6343V147.049H74.6221V133.914Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M74.6221 150.488H84.6343V163.623H74.6221V150.488Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M58.0425 34.5049H68.0547V47.6396H58.0425V34.5049Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M58.0425 51.0786H68.0547V64.2133H58.0425V51.0786Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M58.0425 67.644H68.0547V80.7788H58.0425V67.644Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M58.0425 84.2095H68.0547V97.3442H58.0425V84.2095Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M58.0425 100.783H68.0547V113.918H58.0425V100.783Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M58.0425 117.357H68.0547V130.492H58.0425V117.357Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    d: "M58.0425 133.914H68.0547V147.049H58.0425V133.914Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M58.0425 150.488H68.0547V163.623H58.0425V150.488Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M58.0425 34.5049H68.0547V47.6396H58.0425V34.5049Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M58.0425 51.0786H68.0547V64.2133H58.0425V51.0786Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    d: "M58.0425 67.644H68.0547V80.7788H58.0425V67.644Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M58.0425 84.2095H68.0547V97.3442H58.0425V84.2095Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    d: "M58.0425 100.783H68.0547V113.918H58.0425V100.783Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    d: "M58.0425 117.357H68.0547V130.492H58.0425V117.357Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    d: "M58.0425 133.914H68.0547V147.049H58.0425V133.914Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M58.0425 150.488H68.0547V163.623H58.0425V150.488Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    d: "M41.4536 34.5049H51.4658V47.6396H41.4536V34.5049Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    d: "M41.4536 51.0786H51.4658V64.2133H41.4536V51.0786Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    d: "M41.4536 67.644H51.4658V80.7788H41.4536V67.644Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    d: "M41.4536 84.2095H51.4658V97.3442H41.4536V84.2095Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    d: "M41.4536 100.783H51.4658V113.918H41.4536V100.783Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    d: "M41.4536 117.357H51.4658V130.492H41.4536V117.357Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_91",
    d: "M41.4536 133.914H51.4658V147.049H41.4536V133.914Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_92",
    d: "M41.4536 150.488H51.4658V163.623H41.4536V150.488Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_93",
    d: "M41.4536 34.5049H51.4658V47.6396H41.4536V34.5049Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_94",
    d: "M41.4536 51.0786H51.4658V64.2133H41.4536V51.0786Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_95",
    d: "M41.4536 67.644H51.4658V80.7788H41.4536V67.644Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_96",
    d: "M41.4536 84.2095H51.4658V97.3442H41.4536V84.2095Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_97",
    d: "M41.4536 100.783H51.4658V113.918H41.4536V100.783Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_98",
    d: "M41.4536 117.357H51.4658V130.492H41.4536V117.357Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_99",
    d: "M41.4536 133.914H51.4658V147.049H41.4536V133.914Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_100",
    d: "M41.4536 150.488H51.4658V163.623H41.4536V150.488Z",
    fill: "white",
    fillOpacity: 0.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.05c15b83dee8930e734475a67118b1a9.svg";
export { ForwardRef as ReactComponent };